module.exports = __webpack_public_path__ + "static/media/menu.85b38155.svg";